import catalog from "./catalog.json";
import type { WorkflowDefinition } from "./types";

const loaders: Record<string, WorkflowDefinition["loader"]> = {
  "ocr-searchable-pdf": () => import("./pages/OcrSearchablePdfWorkflow"),
  "secure-pdf": () => import("./pages/SecurePdfWorkflow"),
  "excel-data-pipeline": () => import("./pages/ExcelDataWorkflow"),
  "roster-print-pack": () => import("./pages/RosterPrintWorkflow"),
  "ofd-invoice-summary": () => import("./pages/OfdInvoiceWorkflow"),
  "pdf-form-delivery": () => import("./pages/DelegatedToolWorkflow"),
  "social-publishing-pack": () => import("./pages/DelegatedToolWorkflow"),
  "contact-migration": () => import("./pages/DelegatedToolWorkflow"),
  "har-debug-report": () => import("./pages/DelegatedToolWorkflow"),
  "image-gif-publish": () => import("./pages/DelegatedToolWorkflow"),
};

export const workflows: WorkflowDefinition[] = catalog.map((item) => ({
  ...item,
  loader: loaders[item.id],
}));

export function findWorkflow(slug: string): WorkflowDefinition | undefined {
  return workflows.find((workflow) => workflow.slug === slug);
}
